import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useNotifications, type ApiOptions } from '../helpers';
import { CreateChannelDocument } from './create.generated';

export const useCreateChannel = (options: ApiOptions<typeof CreateChannelDocument> = {}) => {
  const { t } = useTranslation();
  return useMutation(CreateChannelDocument, {
    ...useNotifications(CreateChannelDocument, {
      failure: (error) => error.message || t('api.common.error_generic'),
      success: t('api.channels.create_success'),
    }),

    ...options,
  });
};
